import { render, staticRenderFns } from "./UploadFightVideo.vue?vue&type=template&id=0fd741af"
import script from "./UploadFightVideo.vue?vue&type=script&lang=js"
export * from "./UploadFightVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadFightVideo.vue?vue&type=style&index=0&id=0fd741af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports